import { createContext } from "react";

import { DeviceType } from '../CSS'

export const VirtualArticleContext = createContext<VerticalArticleContextProps>({
    device: 'mobile',
    lang: 'en',
    contentProtection: true,
    navigateToArticle: () => { },
    isSelected: false,
    onLighboxOpen: () => { }
})

export type OnImageContextMenu = (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => void;

export interface VerticalArticleContextProps {
    device: DeviceType;
    lang: string | any;
    onContentProtection?: OnImageContextMenu;
    contentProtection: boolean;
    navigateToArticle?: (articleId: number) => void;
    isSelected: boolean;
    onLighboxOpen: (props: LightboxArgs) => void;
}

export interface LightboxArgs {
    src: string;
    type: 'image';
    caption?: string;
}